module.exports = "<div class=\"aside\" id=\"currencyConversion\">\n    <xo-aside-header heading='asideHeader.currencyOptions'></xo-aside-header>\n    <div class=\"currencyConversion asideContent container\" xo-tray-height>\n       <xo-currency-conversion token=\"token\" done-fn=\"onComplete\"></xo-currency-conversion>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-currency-conversion/template.html
// module id = ./pages/xo-sidebar-currency-conversion/template.html
// module chunks = 1